import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { action } from 'mobx';
import clsx from 'clsx';
import { decorateName } from '@unmapped/core/utils';
import useFilter from '@unmapped/core/hooks/useFilter';
import useComponentOverride from "../../hooks/useComponentOverride.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
export var CheckboxFilter = decorateName(observer(_ref => {
  var {
    name,
    showSelectAll = true,
    selectAllText = 'Show All'
  } = _ref;
  var {
    filterState,
    setFilterState,
    params
  } = useFilter(name);
  var {
    options,
    disabled
  } = params;
  var selectedOptions = useMemo(() => new Set(filterState), [filterState]);
  var styles = useStyleOverride('filters/CheckboxFilter', baseStyles);
  var [CheckboxInput] = useComponentOverride('controls/CheckboxInput');
  var allAreSelected = filterState.length === options.length;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.CheckboxFilter
  }, showSelectAll && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.CheckboxOption, styles.selectAll)
  }, /*#__PURE__*/React.createElement(CheckboxInput, {
    name: name,
    id: "filter-".concat(name, "--selectAllOptions"),
    label: selectAllText,
    checked: allAreSelected,
    disabled: disabled,
    onChange: action("CheckboxFilter('".concat(name, "').selectAllOptions"), e => {
      if (allAreSelected) {
        setFilterState([]);
      } else {
        setFilterState(options.map(opt => opt.value));
      }
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.divider
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.CheckboxOptions
  }, options.map((opt, i) => /*#__PURE__*/React.createElement("div", {
    className: styles.CheckboxOption,
    key: i
  }, /*#__PURE__*/React.createElement(CheckboxInput, {
    name: name,
    type: "checkbox",
    label: opt.label,
    disabled: disabled,
    id: "filter-".concat(name, "-").concat(opt.value),
    checked: selectedOptions.has(opt.value),
    onChange: action("CheckboxFilter('".concat(name, "').toggleSelection('").concat(opt.value, "')"), e => {
      if (selectedOptions.has(opt.value)) {
        selectedOptions.delete(opt.value);
        setFilterState([...selectedOptions]);
      } else {
        selectedOptions.add(opt.value);
        setFilterState([...selectedOptions]);
      }
    })
  })))));
}), 'CheckboxFilter');
export default CheckboxFilter;
//# sourceMappingURL=index.js.map